// extracted by css-extract-rspack-plugin
export default {"quickSearchInput":"quickSearchInput-2-m87"};